import {controllerEndpoint} from '../api';
import sankeyApi from '../Components/Charts/SankeyDiagram/Util/api';

import {bootstrapDangerGrowl as errorGrowl} from "../../../Util/growler";

import Diagram from '../Components/Charts/SankeyDiagram/SankeyDiagram.vue';

export default {
    components: {
        Diagram
    },
    created() {
        this.journeyId = this.initialJourneyId;
        this.loadRemoteData();
    },
    watch: {
        sankeyEndpoint(){
            this.loadRemoteData();
        }
    },
    methods: {
        loadRemoteData(){
            const vm = this;

            sankeyApi.getDataFromEndpoint(vm.sankeyEndpoint).then(
                response => {
                    vm.sankeyData = response.data;
                    vm.sankeyTypes = response.types.sort(({name: left}, {name: right}) => {
                        left = left.toLowerCase();
                        right = right.toLowerCase();
                        
                        //Audience should always be first
                        if(left === 'audience' || right === 'audience'){
                            return left === 'audience' ? -1 : 1;
                        }
                        
                        //Sort the rest alphabetically
                        return left.localeCompare(right);
                    });
                },
                err => errorGrowl(err)
            )
        },
        mapToDisplayedTouchPoint: (touchPoint) => ({
            id: touchPoint.id,
            from: touchPoint.from,
            total: touchPoint.total,
            type: touchPoint.type,
            stripey: false,
            color: touchPoint.isGoal ? '#5dff3e' : null,
            brickId: touchPoint.brickId
        })
    },
    computed: {
        sankeyEndpoint() {
            const {journeyId} = this;

            let endpoint = `${controllerEndpoint}GetSankeyData`;
            if(journeyId){
                endpoint += `/${journeyId}`;
            }

            return endpoint;
        }
    },
    data: () => ({
        sankeyData: [],
        sankeyTypes: [],
        journeyId: null
    }),
    props: {
        initialJourneyId: {
            required: false,
            type: String
        }
    }
}